import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import constant from "../../constants";
import { Header } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import { DatePicker, Spin } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { last } from "ramda";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportUserYear = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs } = Context();
  const [yearUserOrders, setYearUserOrders] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2025");

  const [loading, setLoading] = useState(false);
  const [loadingPercent, setLoadingPercent] = useState(0);

  const [csvFileName, setCsvFileName] = useState(
    `รายงานผู้ใช้รายปี_${selectedYear}.csv`
  );
  const [csvData, setCsvData] = useState([]);

  const getOrders = async () => {
    setLoading(true);
    let newYearUserOrders = {};
    const roundDates = configs?.roundDates || [];
    const targetRoundDate = roundDates.filter(
      (rd) => rd.slice(0, 4) === selectedYear
    );

    for (let rd of targetRoundDate) {
      newYearUserOrders = await getOrder(rd, newYearUserOrders);
      setYearUserOrders(newYearUserOrders);
      setLoadingPercent((prevData) => prevData + 1);
    }

    setLoading(false);
  };

  const getOrder = async (roundDate, newYearUserOrders) => {
    console.log(`calling roundDate ${roundDate}`);
    const roundDateOrderData = [];

    let keepGoing = true;
    let currentIndex = 0;
    var startAtId = "";
    let limit = 10000;

    while (keepGoing) {
      console.log(`calling index ${currentIndex}-${currentIndex + limit}`);
      const data = await callApi(
        "orders-getAll",
        {
          roundDate: roundDate,
          queries: [
            ["roundDate", roundDate],
            ["status", statuses.APPROVE],
          ],
          startAfter: startAtId,
          limit,
          orderBy: ["createdAt", "desc"],
        },
        { notShowLoading: true }
      );

      if (data.length < limit || !data.length || !data) {
        console.log("stop");
        keepGoing = false;
      } else {
        console.log(`fetching size: ${data.length}`);
        console.log("id", data[data.length - 1].id);
        startAtId = data[data.length - 1].id;
      }

      roundDateOrderData.push(...data);
      console.log(`roundDateOrderData size: ${roundDateOrderData.length}`);
      currentIndex += limit;
    }

    newYearUserOrders = roundDateOrderData.reduce((acc, order) => {
      if (acc[order.userId]) {
        acc[order.userId].orders += 1;
        acc[order.userId].size += Number(order.size);
        acc[order.userId].totalPrice += Number(order.totalPrice);
        acc[order.userId].totalPrice_lak += Number(order.totalPrice_lak);
        // if (!acc[order.userId].nationality) {
        //   acc[order.userId].nationality = order.nationality || "TH";
        // }
        if (!acc[order.userId].accName && order.bank?.accName) {
          acc[order.userId].accName = order.bank?.accName;
        }
      } else {
        acc[order.userId] = {
          userId: order.userId,
          phone: order.phone,
          firstName: order.firstName,
          lastName: order.lastName,
          currency: order.paidCurrency,
          accName: order.bank?.accName || "",
          nationality:
            order.nationality || order.paidCurrency === "LAK" ? "LAO" : "TH",
          orders: 1,
          size: Number(order.size),
          totalPrice: Number(order.totalPrice),
          totalPrice_lak: Number(order.totalPrice_lak),
        };
      }
      return acc;
    }, newYearUserOrders);

    return newYearUserOrders;
  };

  const handleDownload = async () => {
    console.log("download");
    const csvBody = [[`รายงานผู้ใช้รายปี_${selectedYear}.csv`]];
    csvBody.push([
      "จ่ายด้วย THB",
      Object.values(yearUserOrders).filter((u) => u.nationality === "TH")
        .length,
    ]);
    csvBody.push([
      "จ่ายด้วย LAK",
      Object.values(yearUserOrders).filter((u) => u.nationality === "LAO")
        .length,
    ]);
    csvBody.push([
      "ลำดับ",
      "ชื่อ-นามสกุล",
      "รหัสผู้ใช้",
      "เบอร์โทรศัพท์",
      "สัญชาติ",
      "ชื่อบัญชีรับเงิน",
      "จำนวนคำสั่งซื้อ",
      "จำนวนสลาก",
      "ราคารวม",
    ]);
    Object.values(yearUserOrders)
      .sort((a, b) => b.totalPrice - a.totalPrice)
      .forEach((user, index) => {
        csvBody.push([
          index + 1,
          `${user.firstName} ${user.lastName}`,
          user.userId,
          user.phone,
          user.nationality || "TH",
          user.accName,
          user.orders.toLocaleString(),
          user.size.toLocaleString(),
          user.currency === "LAK"
            ? user.totalPrice_lak.toLocaleString()
            : user.totalPrice.toLocaleString(),
          user.currency,
        ]);
      });

    setCsvData(csvBody);
    setCsvFileName(`รายงานผู้ใช้รายปี_${selectedYear}.csv`);

    downloadRef.current.link.click();
  };

  return (
    <div className="h-fit w-full min-w-[1024px] max-w-[1600px] mx-auto">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานผู้ใช้รายปี"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">รายงานผู้ใช้รายปี</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">ปี</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
              </select>
            </div>
          </div>
          {/* <div className="gap-2 ">
            <p className="font-medium text-xs">ฟิลเตอร์</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value={"all"}>ทั้งหมด</option>
                <option value={"admin"}>สร้างโดยแอดมิน</option>
              </select>
            </div>
          </div> */}

          <button
            // disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            ค้นหา
          </button>
          <button
            // disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>

      <CSVLink
        data={csvData}
        filename={csvFileName}
        ref={downloadRef}
        style={{ display: "none" }}
      >
        Download me
      </CSVLink>

      {yearUserOrders && (
        <div>
          {Object.values(yearUserOrders).length > 0 ? (
            <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
              {loading && (
                <div className="flex flex-col gap-2 items-center py-48 h-full w-full absolute bg-white/70 top-0 left-0 z-10">
                  <Spinner className="w-3 h-3" />
                  <p className="font-semibold">{loadingPercent}/24</p>
                </div>
              )}
              <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
                <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
                <p className="text-xs font-semibold text-[#969797]">
                  {Object.values(yearUserOrders).length} คำสั่งซื้อ
                </p>
              </div>
              <Table>
                <TableHeader className={`bg-[#f2f3f5]`}>
                  <TableRow>
                    <TableHead className="text-right">ลำดับที่</TableHead>
                    <TableHead className="text-right">รหัสผู้ใช้</TableHead>
                    <TableHead className="text-left">ชื่อ-นามสกุล</TableHead>
                    <TableHead className="text-left">เบอร์โทรศัพท์</TableHead>
                    <TableHead className="text-right">
                      จำนวนคำสั่งซื้อ
                    </TableHead>
                    <TableHead className="text-right">จำนวนสลาก</TableHead>
                    <TableHead className="text-right">ราคารวม</TableHead>
                    <TableHead className="text-right">สกุลเงิน</TableHead>

                    {/* <TableHead>ผู้ยกเลิก</TableHead> */}
                  </TableRow>
                </TableHeader>

                <TableBody className={``}>
                  {Object.values(yearUserOrders).length > 0 ? (
                    Object.values(yearUserOrders)
                      .sort((a, b) => b.totalPrice - a.totalPrice)
                      .map((user, index) => {
                        return (
                          <TableRow key={user.userId}>
                            <TableCell className="font-medium text-right tracking-widest font-mono">
                              {index + 1}
                            </TableCell>
                            <TableCell className="font-medium text-right tracking-widest font-mono">
                              {user.userId}
                            </TableCell>
                            <TableCell className={`font-medium text-left`}>
                              {user.firstName} {user.lastName}
                            </TableCell>
                            <TableCell className="font-medium text-left">
                              {user.phone}
                            </TableCell>
                            <TableCell className="text-right">
                              {user.orders.toLocaleString()}
                            </TableCell>
                            <TableCell className="text-right">
                              {user.size.toLocaleString()}
                            </TableCell>
                            <TableCell className="text-right">
                              {user.currency === "LAK"
                                ? user.totalPrice_lak.toLocaleString()
                                : user.totalPrice.toLocaleString()}
                            </TableCell>
                            <TableCell className="text-right">
                              {user.currency}
                            </TableCell>
                            {/* <TableCell>{order.cancelerName}</TableCell> */}
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableCell className="" colSpan="6">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div className="flex justify-center py-48 h-full w-full">
              <Spinner className="w-3 h-3 mt-4" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
